import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL;

export const fetchPublicCount = createAsyncThunk(
    "waitlistCount/fetchPublicCount",
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axios.get(`${BASE_URL}api/waitlist/count/`);
            return data.total_members;
        } catch {
            return rejectWithValue(null);
        }
    }
);

const WaitlistCountSlice = createSlice({
    name: "waitlistCount",
    initialState: {
        count: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPublicCount.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPublicCount.fulfilled, (state, action) => {
                state.loading = false;
                state.count = action.payload;
            })
            .addCase(fetchPublicCount.rejected, (state) => {
                state.loading = false;
                state.error = true;
            });
    },
});

export default WaitlistCountSlice.reducer;
